module.exports = __webpack_public_path__ + "static/media/instagram-orange.efc40d3b.svg";